(() => {
  const initialize = root => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const form = root.querySelector('form');
    if (!form) return;
    const units = form.querySelector('[data-bespoke-units]');
    const colors = [...form.querySelectorAll('[data-bespoke-color]')];
    const measurements = [...form.querySelectorAll('[data-bespoke-measure]')];
    const summary = root.querySelector('[data-bespoke-summary]');
    const list = root.querySelector('[data-bespoke-summary-list]');
    const dyeStandard = form.querySelector('[data-dye-standard]');
    const dyeCustom = form.querySelector('[data-dye-custom]');
    const dyeColor = form.querySelector('[data-dye-color]');
    let previousUnit = units.selectedOptions[0].dataset.unit;
    let previousFabric = '';
    const update = () => {
      const nextUnit = units.selectedOptions[0].dataset.unit;
      if (nextUnit !== previousUnit) {
        const factor = nextUnit === 'cm' ? 2.54 : 1 / 2.54;
        measurements.forEach(input => {
          if (input.value !== '' && Number.isFinite(input.valueAsNumber)) input.value = String(Math.round(input.valueAsNumber * factor * 100) / 100);
        });
        previousUnit = nextUnit;
      }
      measurements.forEach(input => { input.max = nextUnit === 'cm' ? '300' : '118'; });
      const color = colors.find(input => input.checked);
      if (previousFabric !== (color?.dataset.standardId || '')) {
        dyeStandard.checked = true;
        dyeColor.value = '';
        previousFabric = color?.dataset.standardId || '';
      }
      const naturalSelected = color?.dataset.fabric.trim().toLowerCase() === 'natural';
      const dyeAvailable = Boolean(naturalSelected && color && !color.disabled && color.dataset.dyeId);
      form.querySelector('[data-dye-section]').hidden = !naturalSelected;
      dyeStandard.disabled = !naturalSelected;
      dyeCustom.disabled = !dyeAvailable;
      if (!dyeAvailable && dyeCustom.checked) dyeStandard.checked = true;
      const customDyed = dyeAvailable && dyeCustom.checked;
      colors.forEach(input => { input.value = input === color && customDyed ? input.dataset.dyeId : input.dataset.standardId; });
      if (color?.dataset.price) root.querySelector('[data-bespoke-price]').textContent = customDyed ? color.dataset.dyePrice : color.dataset.price;
      root.querySelector('span[data-dye-surcharge]').textContent = dyeAvailable ? '(+' + color.dataset.dyeSurcharge + ')' : '';
      root.querySelector('[data-dye-status]').textContent = root.querySelector(dyeAvailable ? '[data-dye-available]' : '[data-dye-pending]').content.textContent;
      root.querySelector('[data-dye-details]').hidden = !customDyed;
      dyeColor.disabled = !customDyed;
      dyeColor.required = customDyed;
      const fabricDetail = root.querySelector('[data-fabric-detail]');
      fabricDetail.hidden = !color;
      const fabric = color?.dataset.fabric || '';
      const composition = color?.dataset.composition || '';
      const weight = color?.dataset.weight ? color.dataset.weight + ' oz/yd²' : '';
      root.querySelector('[data-fabric-title]').textContent = fabric;
      root.querySelector('[data-fabric-description]').textContent = color?.dataset.description || '';
      root.querySelector('[data-fabric-spec]').textContent = [composition, weight].filter(Boolean).join(' · ');
      [['[data-fabric-property]', fabric], ['[data-composition-property]', composition], ['[data-weight-property]', weight]].forEach(([selector, value]) => {
        const input = form.querySelector(selector); input.value = value; input.disabled = !value;
      });
      list.replaceChildren();
      const rows = [];
      for (const control of form.querySelectorAll('input[name^="properties["], select[name^="properties["], textarea[name^="properties["]')) {
        if (!control.value || control.disabled || control.type === 'checkbox' || (control.type === 'radio' && !control.checked)) continue;
        rows.push([control.name.slice(11, -1), control.value + (control.hasAttribute('data-bespoke-measure') ? ' ' + nextUnit : '')]);
      }
      rows.forEach(([label,value]) => { const dt=document.createElement('dt'); const dd=document.createElement('dd'); dt.textContent=label; dd.textContent=value; list.append(dt,dd); });
      summary.hidden = rows.length === 0;
      root.dispatchEvent(new CustomEvent('vm:bespoke:update'));
    };
    form.addEventListener('input', update);
    form.addEventListener('change', update);
    form.addEventListener('invalid', event => { const details=event.target.closest('details'); if(details) details.open=true; }, true);
    form.addEventListener('submit', event => {
      update();
      if (!form.checkValidity()) { event.preventDefault(); form.reportValidity(); return; }
      for (const input of measurements) { if (!input.value) input.disabled=true; }
    });
    update();
  };
  const initializeAll = parent => parent.querySelectorAll('[data-vm-bespoke]').forEach(initialize);
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll(document)); else initializeAll(document);
  document.addEventListener('shopify:section:load', event => initializeAll(event.target));
})();
